import React, { useEffect } from "react";
import ProductShowcase from "../../components/cultivars/TropicalCherryBlast/ProductShowcase";
import Footer from "../../components/Footer";
import Cta from "../../components/Cta";
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import FeatureHighlight from "../../components/cultivars/FeatureHighlight";
import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet";

const TropicalCherryBlast = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
     <Helmet>
        <title>Tom Ford Pink Strain - Luxury Cannabis with Rich Flavors | BeyondBloom™</title>
        <meta
          name="description"
          content="Tom Ford Pink is a luxurious strain offering a heavy body high and rich flavors, perfect for deep relaxation."
        />
        <meta
          name="keywords"
          content="Tom Ford Pink strain, luxury cannabis, premium weed, body high strain, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta property="og:title" content="Tom Ford Pink Strain - Luxury Cannabis with Rich Flavors | BeyondBloom™" />
        <meta
          property="og:description"
          content="Tom Ford Pink is a luxurious strain offering a heavy body high and rich flavors, perfect for deep relaxation."
        />
        <meta property="og:image" content="/images/Kush.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/tom-ford-pink" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tom Ford Pink Strain - Luxury Cannabis with Rich Flavors | BeyondBloom™" />
        <meta
          name="twitter:description"
          content="Tom Ford Pink is a luxurious strain offering a heavy body high and rich flavors, perfect for deep relaxation."
        />
        <meta name="twitter:image" content="/images/Kush.png" />
      </Helmet>
      {" "}
      <Navbar />
      <ProductShowcase />
      <FeatureHighlight />
      <CultivarDisplay />
      <Cta />
      <Footer />
    </>
  );
};

export default TropicalCherryBlast;
